"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("./styles");
const ProviderLocationLink = _ref => {
  let {
    location,
    children,
    getLocationUrl,
    locationCallback,
    ...props
  } = _ref;
  const locationUrl = getLocationUrl(location);
  const hasMlocId = location.primary_marketable_location_id;
  const handleClick = e => {
    e.preventDefault();
    locationCallback(locationUrl);
  };
  return /*#__PURE__*/_react.default.createElement(_styles.LocationLinkContainer, null, /*#__PURE__*/_react.default.createElement(_styles.LocationName, (0, _extends2.default)({}, props, {
    title: children
  }), hasMlocId && locationUrl ? /*#__PURE__*/_react.default.createElement(_styles.LocationAnchor, {
    "data-testid": `locationLink-${hasMlocId}`,
    href: locationUrl,
    onClick: handleClick
  }, children) : children));
};
ProviderLocationLink.propTypes = {
  location: _propTypes.default.object.isRequired,
  getLocationUrl: _propTypes.default.func.isRequired,
  children: _propTypes.default.string.isRequired,
  locationCallback: _propTypes.default.func
};
ProviderLocationLink.defaultProps = {
  locationCallback: () => {}
};
var _default = exports.default = ProviderLocationLink;
ProviderLocationLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProviderLocationLink",
  "props": {
    "locationCallback": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "location": {
      "description": "",
      "type": {
        "name": "object"
      },
      "required": true
    },
    "getLocationUrl": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "children": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};